import {
  LinkCategory,
  LinkLabelCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import { ModelConceptRelationship } from 'src/containers/ProjectDiagram/types/data';
import { CreateRelationshipOverrideOptions } from 'src/containers/ProjectDiagram/types/modelConceptRelationship';
import { getModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { getModelConceptRelationshipLabelKey } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/createModelConceptRelationshipLabel';

type CreateModelConceptRelationshipOptions = {
  points?: number[];
  value: string;
} & CreateRelationshipOverrideOptions;

export const getModelConceptRelationshipKey = ({
  fromIri,
  value,
  toIri,
}: {
  fromIri?: string;
  value: string;
  toIri?: string;
}) => `${LinkCategory.MODEL_CONCEPT_RELATIONSHIP}-${fromIri}-${value}-${toIri}`;

export const getRelationshipKeyFromLabelKey = (linkKey: string) =>
  linkKey.replace(
    new RegExp(`^${LinkLabelCategory.MODEL_CONCEPT_RELATIONSHIP_LABEL}`),
    LinkCategory.MODEL_CONCEPT_RELATIONSHIP
  );

export const createModelConceptRelationship = ({
  fromIri,
  value,
  toIri,
  points,
  keyOverride,
  labelKeyOverride,
}: CreateModelConceptRelationshipOptions): ModelConceptRelationship => ({
  key: keyOverride || getModelConceptRelationshipKey({ fromIri, value, toIri }),
  from: fromIri ? getModelConceptClassKey(fromIri) : undefined,
  value,
  to: toIri ? getModelConceptClassKey(toIri) : undefined,
  labelKeys: [
    labelKeyOverride ||
      getModelConceptRelationshipLabelKey({ fromIri, value, toIri }),
  ],
  category: LinkCategory.MODEL_CONCEPT_RELATIONSHIP,
  points,
});
